import React from 'react';

import { ErrorIcon, ErrorIconWrapper, ErrorSquare, ErrorText, ErrorWrapper } from './DepNftAsset.style';

export interface DepAssetErrorProps {
    errorSquareBackground?: boolean;
    noErrorText?: boolean;
}

export function DepAssetError({ noErrorText, errorSquareBackground = true }: DepAssetErrorProps) {
    return (
        <ErrorWrapper>
            <ErrorSquare $background={errorSquareBackground}>
                <ErrorIconWrapper>
                    <ErrorIcon />
                </ErrorIconWrapper>
            </ErrorSquare>

            {noErrorText ? null : <ErrorText>Image not available</ErrorText>}
        </ErrorWrapper>
    );
}
